/**
 * GearShift Pro Racing Sim: Double Seat Swap
 *
 * When a customer picks the "Double Seat" variant on the GearShift Pro
 * product page and clicks Add to Cart, we intercept and add 2x the
 * "Single Seat" variant instead so the cart shows 2 priced line items
 * (1 seat each) totalling the same as the Double Seat price.
 *
 * The Double Seat variant itself never enters the cart — it acts only as
 * a selector trigger.
 */
(function () {
  'use strict';

  // Handle of the GearShift Pro product. Swap only runs on this handle.
  const PRODUCT_HANDLE = '123-game-sit-down-racing-sim-with-gear-stick';

  // Variant IDs on the main GearShift Pro product
  const SINGLE_SEAT_VARIANT_ID = 41431581065355;
  const DOUBLE_SEAT_VARIANT_ID = 41431581098123;

  // When Double Seat is selected, add this many of the Single Seat variant.
  const DOUBLE_SEAT_QUANTITY = 2;

  function getCurrentHandle() {
    const match = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return match ? match[1] : null;
  }

  function attachBundleInterceptor(form) {
    if (form.dataset.racingSimBundleAttached === '1') return;
    form.dataset.racingSimBundleAttached = '1';

    form.addEventListener(
      'submit',
      async (event) => {
        // Find the currently-selected variant in this form
        const variantInput = form.querySelector('[name="id"]');
        if (!variantInput) return;

        const selectedVariantId = parseInt(variantInput.value, 10);
        if (selectedVariantId !== DOUBLE_SEAT_VARIANT_ID) {
          // Not the Double Seat variant, let the default form handler run.
          return;
        }

        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        const submitter =
          event.submitter ||
          form.querySelector('[type="submit"]') ||
          form.querySelector('button[name="add"]');

        if (submitter?.hasAttribute('aria-disabled')) return;

        submitter?.setAttribute('aria-disabled', 'true');
        submitter?.setAttribute('aria-busy', 'true');

        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify({
              items: [
                {
                  id: SINGLE_SEAT_VARIANT_ID,
                  quantity: DOUBLE_SEAT_QUANTITY,
                },
              ],
            }),
          });

          if (!response.ok) {
            const err = await response.json().catch(() => ({}));
            throw new Error(err.description || 'Failed to add to cart');
          }

          const cartResp = await fetch('/cart.js');
          const cart = await cartResp.json();

          if (
            window.theme?.pubsub?.publish &&
            window.theme?.pubsub?.PUB_SUB_EVENTS?.cartUpdate
          ) {
            window.theme.pubsub.publish(
              window.theme.pubsub.PUB_SUB_EVENTS.cartUpdate,
              { source: 'racing-sim-bundle', cart }
            );
          }

          document.documentElement.dispatchEvent(
            new CustomEvent('cart:refresh', { bubbles: true })
          );
          document.dispatchEvent(
            new CustomEvent('ajaxProduct:added', {
              detail: { product: cart },
            })
          );

          const drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.show === 'function') {
            drawer.show(submitter);
          } else {
            window.location.href = '/cart';
          }
        } catch (err) {
          console.error('[racing-sim-bundle] Error:', err);
          document.dispatchEvent(
            new CustomEvent('ajaxProduct:error', {
              detail: { errorMessage: err.message },
            })
          );
          alert(
            err.message ||
              'Sorry, something went wrong adding the seats to your cart.'
          );
        } finally {
          submitter?.removeAttribute('aria-busy');
          submitter?.removeAttribute('aria-disabled');
        }
      },
      true
    );
  }

  function init() {
    const handle = getCurrentHandle();
    if (handle !== PRODUCT_HANDLE) return;

    document
      .querySelectorAll('form[action*="/cart/add"]')
      .forEach(attachBundleInterceptor);

    const observer = new MutationObserver(() => {
      document
        .querySelectorAll('form[action*="/cart/add"]')
        .forEach(attachBundleInterceptor);
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
